/* eslint-disable i18n-scan/no-inline-content */
/* eslint-disable i18n-scan/no-country-dependency */
import { TRACKING } from './trackingDomUtils';

export const STATS_ATTRIBUTE = 'data-cwt-stats';

export const BORDER_STYLES = {
  PS: 'dashed',
  FPTI: 'dotted',
  BOTH: 'double',
};

export const BORDER_COLORS = {
  PS: 'darkmagenta',
  FPTI: 'darkorange',
  BOTH: 'darkgreen',
};

export function checkAndSetAttribute(elem, attributeName, value) {
  if (!elem.style[attributeName]) {
    elem.style[attributeName] = value;
  }
}

export function getDataTypesForBorders(attribute, expectedValue) {
  const dataType = attribute === expectedValue ? 'FPTI' : 'PS';
  const otherType = dataType === 'PS' ? 'FPTI' : 'PS';
  return { dataType, otherType };
}

export default function visualDebug(elem, attribute) {
  if ([TRACKING.FPTI_LOAD, TRACKING.PS_PRESENTMENT].includes(attribute)) {
    [
      ['borderColor', 'gray'],
      ['borderWidth', '1px'],
    ].forEach(([attributeName, value]) => checkAndSetAttribute(elem, attributeName, value));
    const { dataType, otherType } = getDataTypesForBorders(attribute, TRACKING.FPTI_LOAD);
    setStyle(elem, 'borderStyle', BORDER_STYLES[dataType], BORDER_STYLES[otherType], BORDER_STYLES.BOTH);

    if (elem.style.borderStyle === 'double') {
      elem.style.borderWidth = '3px';
    }
    return;
  }
  if ([TRACKING.FPTI_IMPRESSION, TRACKING.PS_IMPRESSION].includes(attribute)) {
    [
      ['borderStyle', 'solid'],
      ['borderWidth', '1px'],
    ].forEach(([attributeName, value]) => checkAndSetAttribute(elem, attributeName, value));
    const { dataType, otherType } = getDataTypesForBorders(attribute, TRACKING.FPTI_IMPRESSION);

    setStyle(elem, 'borderColor', BORDER_COLORS[dataType], BORDER_COLORS[otherType], BORDER_COLORS.BOTH);
    return;
  }
  if ([TRACKING.FPTI_CLICK, TRACKING.PS_CLICK].includes(attribute)) {
    [
      ['outlineStyle', 'solid'],
      ['outlineWidth', '2px'],
    ].forEach(([attributeName, value]) => checkAndSetAttribute(elem, attributeName, value));
    const { dataType, otherType } = getDataTypesForBorders(attribute, TRACKING.FPTI_CLICK);

    setStyle(elem, 'outlineColor', BORDER_COLORS[dataType], BORDER_COLORS[otherType], BORDER_COLORS.BOTH);
  }
}

export function setStyle(elem, styleProp, value, otherValue, bothValue) {
  const currentStyle = elem.style[styleProp];
  if (currentStyle === otherValue) {
    elem.style[styleProp] = bothValue;
  } else if (![value, otherValue, bothValue].includes(currentStyle)) {
    elem.style[styleProp] = value;
  }
}

export function addStats(elem, attribute, data) {
  if (!elem.__cwtStats) {
    elem.__cwtStats = [];
    elem.setAttribute(STATS_ATTRIBUTE, 'true');
  }
  elem.__cwtStats.push({
    date: new Date(Date.now()),
    attribute,
    data,
  });
}

export function getTrackingAttributes(el) {
  return Object.fromEntries(
    el
      .getAttributeNames()
      .filter((name) => name.indexOf('data-cwt') === 0 && name !== STATS_ATTRIBUTE)
      .map((name) => [name, el.getAttribute(name)])
  );
}

export function getTimeAgo(now, date) {
  const dt = now - date.getTime();
  if (dt < 60000) {
    return `${Math.floor(dt / 1000)} secs ago`;
  }
  if (dt < 3600000) {
    return `${Math.floor(dt / 60000)} mins ago`;
  }
  return `${Math.floor(dt / 3600000)} hrs ago`;
}

const TRACKING_DESCRIPTION = {
  [TRACKING.PS_CLICK]: 'PS Click',
  [TRACKING.PS_IMPRESSION]: 'PS Impression',
  [TRACKING.PS_PRESENTMENT]: 'PS Presentment',
  [TRACKING.FPTI_CLICK]: 'FPTI Click',
  [TRACKING.FPTI_IMPRESSION]: 'FPTI Impression',
  [TRACKING.FPTI_LOAD]: 'FPTI Load',
};

export function consoleLogStats(eventElement) {
  const elem = eventElement.closest(`[${STATS_ATTRIBUTE}]`);
  if (!elem) {
    return;
  }
  console.group(`elem ${elem.className}`);
  consoleLogElementInfo(elem);
  consoleLogEventData(elem.__cwtStats);
  console.groupEnd();
}

export function consoleLogElementInfo(elem) {
  console.log(elem);
  console.groupCollapsed('attributes');
  console.table(getTrackingAttributes(elem));
  console.groupEnd();

  let hasBaseProps = false;
  let closest = elem;
  while (closest) {
    if (!hasBaseProps) {
      hasBaseProps = true;
      console.groupCollapsed('baseProps');
    }
    const base = closest.getAttribute(TRACKING.FPTI_BASE);
    if (base) {
      console.group(`baseProps: ${closest.className}`);
      console.log(closest);
      console.table(JSON.parse(base));
      console.groupEnd();
    }
    closest = closest.parentNode.closest(`[${TRACKING.FPTI_BASE}]`);
  }
  if (hasBaseProps) {
    console.groupEnd();
  }
}

export function consoleLogEventData(data) {
  if (!data) {
    return;
  }
  data.forEach(({ date, attribute, data }) => {
    console.group(
      [
        TRACKING_DESCRIPTION[attribute],
        [date.toLocaleTimeString(), date.getMilliseconds()].join(':'),
        getTimeAgo(new Date(Date.now()), date),
      ].join(' ')
    );
    if (typeof data === 'string') {
      console.table({ URL: data });
    } else {
      console.table(data);
    }
    console.groupEnd();
  });
}
